import {h, Component} from 'preact';
import Spinner from '@components/common/Spinner';
import {
    GetCustomerEquipment,
    GetRmasByAccountNumber,
    GetRepairsCart,
    GetCustomerAddresses
} from '@services/SmsService/query.graphql';
import {graphql, compose as composeQuery} from 'react-apollo';
import SmsService from '@services/SmsService';
import {AppRouter} from './router';
import Provider from 'preact-context-provider';

class App extends Component {

    state = {isPrintingLabel: false};

    constructor ( props ) {
        super( props );

        this.clearCart = this.clearCart.bind( this );
        this.printShippingLabel = this.printShippingLabel.bind( this );

        // debug -> add bad cart items
        // window.SMS_ADD_BAD_SKUS = () => {
        //     var badItems = [
        //         {serialId: 'CB0671', equipmentIssue: 'na', injury: false},
        //         {serialId: 'CB1542', equipmentIssue: 'na', injury: true}
        //     ];
        //
        //     badItems.forEach( input => this.addItem( input ) );
        // };
    }

    clearCart () {
        console.warn( '[SmsClearCart]' );
        return SmsService.clearRepairsCart();
    }

    addItem ( {serialId, equipmentIssue = 'NA', injury = false} ) {
        console.warn( '[SmsAddItem]', {serialId, equipmentIssue, injury} );
        return SmsService.addRepairItem( {serialId, equipmentIssue, injury} );
    }

    removeItem ( {serialId} ) {
        console.warn( '[SmsRemoveItem]', {serialId} );
        return SmsService.removeRepairItem( {serialId} );
    }

    printShippingLabel ( {base64Image} ) {
        this.setState( {
            isPrintingLabel: true,
            shippingLabelImage: base64Image
        } );

        setTimeout( () => {
            window.print();
            this.setState( {
                isPrintingLabel: false,
                shippingLabelImage: null
            } );
        }, 10 );
    }

    render ( {equipmentData, addressData, rmaData, cartData} ) {
        if ( equipmentData.loading ) {
            return (
                <div className="cover-page flex justify-center items-center">
                    <Spinner className="md:text-xl" message="Loading your equipment purchases"/>
                </div>
            );
        }

        if ( equipmentData.error ) {
            console.log( equipmentData.error.networkError );
        }

        const sendProps = {
            equipmentData,
            addressData,
            rmaData,
            cartData,
            customerEquipment: equipmentData.customerEquipment || [],
            customerAddresses: addressData.smsAddressesByAccountNumber || [],
            customerRmas: rmaData.rmasByAccountNumber || [],
            cart: cartData.smsCart || [],
            // todo -> maybe refactor NOT using "state" prop and just spread
            state: {
                ...this.state
            },
            actions: {
                clearCart: this.clearCart,
                addItem: this.addItem,
                removeItem: this.removeItem,
                refetchRmaList: rmaData.refetch,
                printShippingLabel: this.printShippingLabel
            }
        };

        return (
            <Provider {...sendProps}>
                <AppRouter/>
            </Provider>
        );
    }
}

export default composeQuery(
    graphql( GetCustomerEquipment, {
        name: 'equipmentData',
        options: {
            fetchPolicy: 'network-only'
        }
    } ),
    graphql( GetCustomerAddresses, {
        name: 'addressData'
    } ),
    graphql( GetRmasByAccountNumber, {
        name: 'rmaData',
        options: {
            fetchPolicy: 'network-only'
        }
    } ),
    graphql( GetRepairsCart, {
        name: 'cartData'
    } )
)( App );